@if (dictionaryArray && formControl()) {
<div class="dictionary">
    <div class="row">
        <div class="caption">{{meta().info}}</div>
        <div class="array" [formArray]="dictionaryArray">
            @for (entry of dictionary; track i; let i = $index) {
            <div class="item">
                <div class="left">
                    <app-text style="width: 50%" [formGroup]="$any(dictionaryArray.at(i))" [model]="entry.key"
                        [meta]="metaKey" [readonly]="readonly()" (clear)="clearKey(i)"></app-text>
                    <app-text style="width: 50%" [formGroup]="$any(dictionaryArray.at(i))" [model]="entry.value"
                        [meta]="metaValue" [readonly]="readonly()" (clear)="clearValue(i)"></app-text>
                </div>
                <div class="right">
                    <button type="button" matPrefix class="button" [disabled]="readonly()"
                        (click)="onDelete(i)"><mat-icon>delete</mat-icon></button>
                </div>
            </div>
            }
        </div>
        @if (dictionaryArray.hasError('dictionary')) {
        <mat-error>
            Duplicate key is not allowed.
        </mat-error>
        }
        <button type="button" class="button" (click)="onAdd()"
            [disabled]="readonly()"><mat-icon>add_box</mat-icon></button>
    </div>
</div>
}
